import { PageLayout } from '@common/components/PageLayout';
import PlanDetailsWrapper from '@features/plan_and_usage/components/PlanDetailsWrapper';

export default function PlanDetails() {
	return (
		<PageLayout title='Plan Details'>
			<PlanDetailsWrapper />
		</PageLayout>
	);
}
